export default "__VITE_ASSET__aa1e29d1__"